import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect } from "react";
export const DatabaseValue = createContext(null);
export const DatabaseDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  switch (action.type) {
    case "set":
      return action.value;
    case "addField":
      console.log("hit add field reducer");
      newState[action.docId].fields[action.name] = action.value;
      return newState;
    case "renameField":
      console.log("hit rename field reducer");
      newState[action.docId].fields[action.field].name = action.value;
      console.log(newState);
      return newState;
    case "deleteField":
      console.log("hit delete field reducer");
      delete newState[action.docId].fields[action.field];
      return newState;
    default:
      return newState;
  }
};

export default function DatabaseContext({ children }) {
  const [state, dispatch] = useReducer(reducer, []);
  const { appId, docId } = useParams();

  useEffect(() => {
    if (appId) {
      db.collection("apps")
        .doc(appId)
        .collection("tables")
        .onSnapshot((snap) => {
          const data = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          const sortedData = data.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          dispatch({ type: "set", value: sortedData });
        });
    }
  }, [appId]);

  return (
    <DatabaseValue.Provider value={state}>
      <DatabaseDisbatch.Provider value={dispatch}>
        {children}
      </DatabaseDisbatch.Provider>
    </DatabaseValue.Provider>
  );
}
